import { render, staticRenderFns } from "./text-link.vue?vue&type=template&id=62904e53&scoped=true&lang=pug"
import script from "./text-link.vue?vue&type=script&lang=coffee"
export * from "./text-link.vue?vue&type=script&lang=coffee"
import style0 from "./text-link.vue?vue&type=style&index=0&id=62904e53&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62904e53",
  null
  
)

export default component.exports